import styled from "styled-components"

export const CloseContainer = styled.div`
  overflow: auto;
  max-height: 600px;
  width: 100%;

  .title {
    font-size: 16px;
    font-weight: 600;
  }

  .actions-buttons {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 25px;
    width: 100%;
    margin-top: 20px;

    button {
      color: #2B0C1A;
      cursor: pointer;
      font-size: 16px;      
      font-weight: 400;      
      line-height: 20px;
      padding: 12px 32px;
      border: 1px solid #DCDCE3;

      &.save {
        background-color: #F5CB2B;
      }
      
      &.cancel {
        background-color: #B3B3B3;
      }

      &:hover {
        text-decoration: underline;
      }

      &:disabled {
        cursor: default;
        background-color: #DCDCE3;
        
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`